// CANONICAL COPY (GH #7115). src/constants/obligations/obl-cra-product-risk-assessment.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-cra-product-risk-assessment',
  title: 'Perform and document a per-product cybersecurity risk assessment',
  description:
    'For each product with digital elements (PDE) that is in scope, the manufacturer must carry out a cybersecurity risk assessment (CRA Art. 13(2) and Annex I, Part I §1.1), document it, and address identified risks throughout the planning, design, development, production, delivery and maintenance phases. The assessment must be included in the technical documentation and refreshed at least annually. A reference to the risk assessment and its date must be recorded per product.',
  category: 'risk',
  scfIds: ['SCF-RSK-001', 'SCF-RSK-002'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'per-product',
  perProductCriteria: [
    {
      type: 'product-risk-assessment-current',
      description: 'Risk assessment reference set and dated within the last 12 months',
    },
  ],
  domainActions: [],
};
